// Application constants

export const MAX_DATA_POINTS = 360; // Keep last 360 data points (30 minutes at 5s intervals)
